import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'

import AppointmentForm from './AppointmentForm'

import { storeAppointment } from '../services'
import { handleError } from '../../../helpers'

export default function NewAppointmentModal({ visible, onClose, reload, defaultOrder = null, defaultAppointment = null }) {
    const user = useSelector(state => state.auth.user)
    const { handleSubmit, register, formState: { errors }, watch, setValue, setError, clearErrors } = useForm({
        defaultValues: {
            order_id: defaultOrder?.id,
            warehouse_id: defaultOrder?.warehouse_id,
            booked_by_name: defaultAppointment?.booked_by_name,
            schedule_at: defaultAppointment?.schedule_at,
            location_sku: defaultAppointment?.location_sku,
        }
    })
    const [loading, setLoading] = useState(false)

    const onSubmit = values => {
        setLoading(true)
        storeAppointment({...values, supplier_id: user.id})
            .then(res => {
                message.success(res.data.message)
                reload()
                onClose()
            })
            .catch(error => handleError(error, setLoading))
    }

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Agendar Cita</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <AppointmentForm 
                            register={register}
                            errors={errors}
                            watch={watch}
                            setValue={setValue}
                            setError={setError}
                            clearErrors={clearErrors}
                            defaultOrder={defaultOrder}
                        />
                        <div className='text-right'>
                            <Button 
                                color="primary" 
                                type="submit" 
                                disabled={loading}
                            >
                                { loading && <Spinner animation='border' size="sm" className='mr-5' /> }
                                Agendar Cita Nueva
                            </Button>
                        </div>
                    </Form>
                </ModalBody>
			</Modal>
		</React.Fragment>
	)
}